import SecondServer from "./SecondServer"
import { userOptions } from "../database/apiUrls";

export async function GetOptions (props) {
  const ss = new SecondServer (props)
  const resp = await ss.apiData(userOptions())
  return resp?.data?.data?.options
}
export function GetOption (allOpts, name) {
  if (!Array.isArray(allOpts))
    return undefined
  return allOpts?.find(i=>i.parameter === name)
}
export async function SaveOption(opt, props) {
  const cache = await GetOptions(props)
  const current = cache ? GetOption (cache, opt?.parameter) : cache
  const url = urlify (opt)
  const ss = new SecondServer (props)
  return current ? await ss.apiSaveData(url) : await ss.apiInsertData(url)
}
export function urlify (opt) {
  return userOptions() + "&name="+opt?.parameter+ "&value=" + encodeURIComponent(opt?.value)
}
export function encodeOpt(name, val) {
  return {parameter: name, value: val}
}
